/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_RosInputs */

const en_val_ros = /** @type {(inputs: Val_RosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rosé`)
};

const es_val_ros = /** @type {(inputs: Val_RosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rosado`)
};

const fr_val_ros = /** @type {(inputs: Val_RosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rosé`)
};

const de_val_ros = /** @type {(inputs: Val_RosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rosé`)
};

const ja_val_ros = /** @type {(inputs: Val_RosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロゼワイン`)
};

const zh_val_ros = /** @type {(inputs: Val_RosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`桃红葡萄酒`)
};

const ar_val_ros = /** @type {(inputs: Val_RosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نبيذ وردي (Rosé)`)
};

const id_val_ros = /** @type {(inputs: Val_RosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rosé`)
};

const it_val_ros = /** @type {(inputs: Val_RosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rosato`)
};

const ru_val_ros = /** @type {(inputs: Val_RosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Розовое`)
};

const pt_val_ros = /** @type {(inputs: Val_RosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rosé`)
};

const ko_val_ros = /** @type {(inputs: Val_RosInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로제`)
};

/**
* | output |
* | --- |
* | "Rosé" |
*
* @param {Val_RosInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_ros = /** @type {((inputs?: Val_RosInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_RosInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_ros(inputs)
	if (locale === "es") return es_val_ros(inputs)
	if (locale === "fr") return fr_val_ros(inputs)
	if (locale === "de") return de_val_ros(inputs)
	if (locale === "ja") return ja_val_ros(inputs)
	if (locale === "zh") return zh_val_ros(inputs)
	if (locale === "ar") return ar_val_ros(inputs)
	if (locale === "id") return id_val_ros(inputs)
	if (locale === "it") return it_val_ros(inputs)
	if (locale === "ru") return ru_val_ros(inputs)
	if (locale === "pt") return pt_val_ros(inputs)
	return ko_val_ros(inputs)
});